import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap, faCertificate } from "@fortawesome/free-solid-svg-icons";

const Container = styled.div`
  padding: 8rem 2rem;
  background: transparent;
  color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 2.5rem);
  text-align: center;
  margin-bottom: 5rem;
  color: #ffffff;
  font-weight: 800;
  font-family: "Outfit", "Inter", sans-serif;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  position: relative;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #E2A44A, #e74c3c);
    border-radius: 2px;
  }
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 3rem;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const SectionTitle = styled.h3`
  font-size: 1.8rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: "Outfit", "Inter", sans-serif;

  svg {
    color: #4A90E2;
  }
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(20px) saturate(180%);
  border-radius: 20px;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.03);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  height: 100%;
  position: relative;
  overflow: hidden;

  /* Premium "Machined Glass" Inner Border */
  &::after {
    content: '';
    position: absolute;
    inset: 1px;
    border-radius: 19px;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.15);
    pointer-events: none;
    z-index: 2;
  }

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(74, 144, 226, 0.3);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4), 0 0 40px rgba(74, 144, 226, 0.1);
  }
`;

const ItemTitle = styled.h4`
  font-size: 1.2rem;
  color: #fff;
  margin-bottom: 0.5rem;
  font-family: "Outfit", "Inter", sans-serif;
`;

const ItemSubtitle = styled.p`
  font-size: 0.95rem;
  color: #4A90E2;
  margin-bottom: 1rem;
  font-weight: 500;
`;

const ItemDetail = styled.p`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
`;

const Education = () => {
  return (
    <Container id="education">
      <Title>Education & Certifications</Title>

      <ContentGrid>
        <SectionContainer>
          <SectionTitle>
            <FontAwesomeIcon icon={faGraduationCap} /> Education
          </SectionTitle>

          <Card>
            <ItemTitle>MSc Computer Science (Software Engineering)</ItemTitle>
            <ItemSubtitle>University of Wrexham, 2023</ItemSubtitle>
            <ItemDetail>
              Merit. <br />
              Dissertation: AI & Machine Learning for Competitive Advantage in Sport
            </ItemDetail>
          </Card>

          <Card>
            <ItemTitle>BA (Hons) Professional Golf (Business & Sports Science)</ItemTitle>
            <ItemSubtitle>University of Birmingham, 2011</ItemSubtitle>
          </Card>
        </SectionContainer>

        <SectionContainer>
          <SectionTitle>
            <FontAwesomeIcon icon={faCertificate} /> Certifications
          </SectionTitle>

          <Card>
            <ItemTitle>CompTIA (In Progress)</ItemTitle>
            <ItemDetail>
              Strategic enhancement of technical governance and IT management knowledge.
            </ItemDetail>
          </Card>

          <Card>
            <ItemTitle>Trackman Master Professional</ItemTitle>
            <ItemDetail>
              Advanced sports analytics and decision modelling.
            </ItemDetail>
          </Card>

          <Card>
            <ItemTitle>PGA Accredited Professional</ItemTitle>
            <ItemDetail>
              Elite-level performance underpinned by strategic planning, discipline, and leadership.
            </ItemDetail>
          </Card>
        </SectionContainer>
      </ContentGrid>
    </Container>
  );
};

export default Education;
